import React from "react";
import {compose} from "redux";
import {translate} from "react-i18next";
import {Button, Col, Form, Row} from "antd";
import {GUTTER_MD, MARGIN_MD, SPAN_FULL} from "../../../../styles/constants";
import FileInput from "../../../../components/file-input";
import {connect} from "react-redux";
import {submitPluginInputFiles} from "../actions";
import {isExtensionInvalid} from "../../../../utils/artefactValidators";

const mapStateToProps = state => ({
    pluginForm: state.scenes.utilities.plugins.pluginForm,
})

const mapDispatchToProps = dispatch => ({
    onFileSubmit: (pluginUid, file, transformFile, processFile) => dispatch(submitPluginInputFiles(pluginUid, file, transformFile, processFile)),
});

const FirstStep = ({plugin, form, t, onFileSubmit, pluginForm}) => {
    return <Form className="advanced-form">
        <Row style={{marginBottom: MARGIN_MD}} gutter={GUTTER_MD}>
            <Col span={SPAN_FULL}>
                <Form.Item className="form-item-required" label={t('scenes.utilities.plugin.modal.input.file.label')}
                           required
                           validateStatus={pluginForm.file && isExtensionInvalid(pluginForm.file.name, plugin.InputExtensions) ? "warning" : null}
                           help={pluginForm.file && isExtensionInvalid(pluginForm.file.name, plugin.InputExtensions) ? t("scenes.utilities.plugin.modal.input.messages.invalidExtension") : null}
                >
                    {form.getFieldDecorator('file')(
                        <FileInput
                            accept={plugin.InputExtensions.join(",")}
                        />
                    )}
                </Form.Item>
            </Col>
        </Row>
        {['TransformFileEnabled', 'ProcessFileEnabled'].map(fieldName => {
            if (!plugin[fieldName]) {
                return null;
            }
            const lowercaseField = `${fieldName[0].toLowerCase()}${fieldName.substring(1)}`.replace("Enabled", "Input");
            const isProcess = fieldName.includes("Process");
            return (
                <Row style={{marginBottom: MARGIN_MD}} gutter={GUTTER_MD} key={fieldName}>
                    <Col span={SPAN_FULL}>
                        <Form.Item className="form-item-required"
                                   label={t(`scenes.utilities.plugin.modal.input.${lowercaseField}.label`)} required
                                   validateStatus={((isProcess && pluginForm.processFileInput) || (!isProcess && pluginForm.transformFileInput)) &&
                                   isExtensionInvalid(isProcess ? pluginForm.processFileInput.name : pluginForm.transformFileInput.name, isProcess ? [plugin.ProcessExtension] : [plugin.TransformExtension]) ? "warning" : null}
                                   help={((isProcess && pluginForm.processFileInput) || (!isProcess && pluginForm.transformFileInput)) &&
                                   isExtensionInvalid(isProcess ? pluginForm.processFileInput.name : pluginForm.transformFileInput.name, isProcess ? [plugin.ProcessExtension] : [plugin.TransformExtension]) ? t("scenes.utilities.plugin.modal.input.messages.invalidExtension") : null}
                        >
                            {form.getFieldDecorator(lowercaseField)(
                                <FileInput
                                    accept={fieldName.includes("Process") ? plugin.ProcessExtension : plugin.TransformExtension}
                                />
                            )}
                        </Form.Item>
                    </Col>
                </Row>
            )
        })}
        <Row style={{marginBottom: MARGIN_MD}} type="flex" justify="end" gutter={GUTTER_MD}>
            <Col>
                <Button
                    disabled={
                        !pluginForm.file ||
                        isExtensionInvalid(pluginForm.file.name, plugin.InputExtensions)||
                        (plugin.TransformFileEnabled && (!pluginForm.transformFileInput || isExtensionInvalid(pluginForm.transformFileInput.name, [plugin.TransformExtension]))) ||
                        (plugin.ProcessFileEnabled && (!pluginForm.processFileInput || isExtensionInvalid(pluginForm.processFileInput.name, [plugin.ProcessExtension])))
                    }
                    icon="upload"
                    type="primary"
                    onClick={() => onFileSubmit(plugin.PluginUid, pluginForm.file, pluginForm.transformFileInput, pluginForm.processFileInput)}
                >
                    {t('scenes.utilities.plugin.modal.input.uploadButton.label')}
                </Button>
            </Col>
        </Row>
    </Form>
}

export default compose(
    translate(),
    connect(mapStateToProps, mapDispatchToProps),
)(FirstStep);